import { connect } from 'react-redux'
import { formatContentSelectValue, filterOptionsFunction } from '../../../utils'
import { preRegistrationsActions, messageActions } from '../../../actions'
import { withStyles } from '@material-ui/core/styles'
import * as API from '../../../api'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import React, { Component, Fragment } from 'react'
import SelectWrapped from '../../../components/SelectWrapped'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../../utils/permissions'

import { CopyrightField, EdicaoField, IsbnField } from '../../../components/Fields'

const styles = theme => ({
  layout: {
    height: 'calc(100% - 64px)',
    position: 'relative'
  },
  preRegistrationForm: {
    background: '#fff',
    height: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 3,
    overflow: 'auto'
  },
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '12px 0'
  },
  uploadButton: {
    margin: '15px 0',
    padding: '0 16px',
    background: 'rgb(0, 45, 114)',
    color: '#fff'
  },
  uploadButtonIcon: {
    color: 'inherit !important',
    marginLeft: '3px'
  },
  formSelect: {
    marginTop: '23px',
    paddingBottom: '12px'
  }
})

class Curso extends Component {
  render() {
    const {
      classes,
      preRegistration,
      handleChangePreRegistration,
      preRegistrationFormErrors,
      formTouched,
      token
    } = this.props

    const isReadOnly = readOnly(preRegistration.tipo, token)

    return (
      <Fragment>
        <FormControl
          error={!((preRegistrationFormErrors.fields || {})['titulo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-titulo">Título</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            onChange={e => {
              handleChangePreRegistration({ ...preRegistration, titulo: e.target.value })
            }}
            value={preRegistration.titulo}
            id="field-titulo"
          />
          {!((preRegistrationFormErrors.fields || {})['titulo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['titulo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>

        <div className={classes.formSelect}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangePreRegistration({ ...preRegistration, autores: obj })
            }}
            error={
              !((preRegistrationFormErrors.fields || {})['autores'] || {}).valid && formTouched
            }
            value={formatContentSelectValue(preRegistration.autores || [])}
            placeholder="Selecione..."
            name="react-select-chip-label"
            label="Coordenadores"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-label',
                loadOptions: API.authors.getSelectAuthors,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((preRegistrationFormErrors.fields || {})['autores'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['autores'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>

        <div className={classes.formSelect}>
          <TextField
            disabled={isReadOnly}
            fullWidth
            onChange={obj => {
              handleChangePreRegistration({ ...preRegistration, especialidades: obj })
            }}
            error={
              !((preRegistrationFormErrors.fields || {})['especialidades'] || {}).valid &&
              formTouched
            }
            value={formatContentSelectValue(preRegistration.especialidades || [])}
            placeholder="Selecione..."
            name="react-select-chip-especialidades"
            label="Especialidades"
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              inputComponent: SelectWrapped,
              inputProps: {
                multi: true,
                filterOptions: filterOptionsFunction,
                instanceId: 'react-select-chip-label',
                id: 'react-select-chip-especialidades',
                loadOptions: API.specialities.getSelectSpecialities,
                disableDelete: isReadOnly
              }
            }}
          />
          {!((preRegistrationFormErrors.fields || {})['especialidades'] || {}).valid &&
          formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['especialidades'] || {}).errorMessage}
            </Typography>
          ) : null}
        </div>

        <FormControl
          error={!((preRegistrationFormErrors.fields || {})['codigo'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-codigo">Código Protheus</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={IsbnField}
            onChange={e => {
              handleChangePreRegistration({ ...preRegistration, codigo: e.target.value })
            }}
            value={preRegistration.codigo || ''}
            id="field-codigo"
          />
          {!((preRegistrationFormErrors.fields || {})['codigo'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['codigo'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>

        <FormControl
          error={
            !((preRegistrationFormErrors.fields || {})['copyright'] || {}).valid && formTouched
          }
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-copyright">Ano de realização</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={CopyrightField}
            onChange={e => {
              handleChangePreRegistration({ ...preRegistration, copyright: e.target.value })
            }}
            value={preRegistration.copyright || ''}
            id="field-copyright"
          />
          {!((preRegistrationFormErrors.fields || {})['copyright'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['copyright'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>

        <FormControl
          error={!((preRegistrationFormErrors.fields || {})['edicao'] || {}).valid && formTouched}
          className={classes.formControl}
          fullWidth
        >
          <InputLabel htmlFor="field-edicao">Edição</InputLabel>
          <Input
            disabled={isReadOnly}
            fullWidth
            required={'required'}
            type="text"
            inputComponent={EdicaoField}
            onChange={e => {
              handleChangePreRegistration({ ...preRegistration, edicao: e.target.value })
            }}
            value={preRegistration.edicao || ''}
            id="field-edicao"
          />
          {!((preRegistrationFormErrors.fields || {})['edicao'] || {}).valid && formTouched ? (
            <Typography className={classes.errorMessage} noWrap color={'error'}>
              {((preRegistrationFormErrors.fields || {})['edicao'] || {}).errorMessage}
            </Typography>
          ) : null}
        </FormControl>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    preRegistration: state.preRegistrations.preRegistration,
    preRegistrationFormErrors: state.preRegistrations.preRegistrationFormErrors,
    formTouched: state.preRegistrations.preRegistrationFormTouched,
    conteudoHtml: state.preRegistrations.conteudoHtml,
    token: state.auth.token
  }
}
const mapDispatchToProps = dispatch => {
  return {
    handleChangePreRegistration: preRegistration => {
      dispatch(preRegistrationsActions.handleChangePreRegistration(preRegistration))
    },
    setPreRegistrationFormTouched: () => {
      return dispatch(preRegistrationsActions.setPreRegistrationFormTouched())
    },
    removeHtmlDocument: () => {
      return dispatch(preRegistrationsActions.removeHtmlDocument())
    },
    getHtmlPreview: preRegistration => {
      return dispatch(preRegistrationsActions.getHtmlPreview(preRegistration))
    },
    changeMessage: ({ message, anchorOrigin }) => {
      dispatch(messageActions.changeMessage({ message, anchorOrigin }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(Curso))



// WEBPACK FOOTER //
// ./src/containers/PreRegistration/PreRegistrationTypes/Curso.js